var _defs, _circle, _path, _path2, _path3, _path4, _path5, _polygon, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 471.66,
    height: 471.66,
    viewBox: "0 0 471.66 471.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 212.77,
    y1: 38.39,
    x2: 436.94,
    y2: 238.66,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 474)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00b2ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2ec0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6dd3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#a1e3f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#caeffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#e7f8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#f9fdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 219.35,
    y1: 31.01,
    x2: 443.53,
    y2: 231.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 288.91,
    y1: 114.54,
    x2: 288.91,
    y2: 114.54,
    xlinkHref: "#a"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 235.83,
    cy: 235.83,
    r: 235.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.58,371.5l1.32,1Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304.78,374.52c-1-.67-2-1.35-2.88-2C302.81,373.17,303.77,373.85,304.78,374.52Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.75,361.93l-1.84-2.47,1.84,2.47A57.94,57.94,0,0,0,297,368.5,57.94,57.94,0,0,1,290.75,361.93Z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M299.31,370.48l1.27,1h0Z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.19,325.66h-.31a89.84,89.84,0,1,1-.1-179.68h0A89.79,89.79,0,0,1,321,264.26l40.37,54.25a150.36,150.36,0,1,0-83.95,61.75C275.88,378.62,236.19,325.66,236.19,325.66Z",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "288.91 359.46 288.91 359.46 288.91 359.46 288.91 359.46",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M384.13,385.83,332.46,316.4,304.62,279h0l-1.84-2.47c-.47-.57-1-1.25-1.69-2a60.23,60.23,0,0,0-4.58-4.6c-.72-.65-1.48-1.31-2.29-2-.41-.34-.84-.68-1.28-1s-.86-.67-1.31-1c-.91-.68-1.87-1.36-2.89-2-9.11-6-22.32-11.61-40.1-11.61H209.4l.15.2-.15.1,51.67,69.44,27.84,37.41h0l1.84,2.47c.46.58,1.05,1.25,1.69,2a58.47,58.47,0,0,0,4.58,4.6c.72.65,1.48,1.31,2.29,2l1.27,1,1.32,1c.91.67,1.87,1.35,2.88,2,9.11,6,22.33,11.61,40.11,11.61h39.24L384,386Z",
    fill: "#00b2ec"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQi);
export default __webpack_public_path__ + "static/media/qi.900676c5499be50149fd1d9f74571fed.svg";
export { ForwardRef as ReactComponent };